const scrollToElement = (element: string): void => {
  const el: HTMLElement | null = document.getElementById(element);
  if (el) {
    el.scrollIntoView({behavior: 'smooth'});
  }
};

export {scrollToElement};
